import checkConstAvailability from '~/utils/check-const-availability';

const EXCHANGE_URL = process.env.VUE_APP_EXCHANGE_URL;

const VERIFICATION_TYPE = {
  MANUAL: 0,
  AUTO: 1,
  MANUAL_AUTO: 2,
  AUTO_MANUAL: 3,
};

const VERIFICATION_TYPE_LIST = [
  {
    id: VERIFICATION_TYPE.MANUAL,
    caption: 'Manual',
  },
  {
    id: VERIFICATION_TYPE.AUTO,
    caption: 'Auto',
  },
  {
    id: VERIFICATION_TYPE.MANUAL_AUTO,
    caption: 'Manual auto',
  },
  {
    id: VERIFICATION_TYPE.AUTO_MANUAL,
    caption: 'Auto manual',
  },
].filter((e) => checkConstAvailability(e, { VERIFICATION_TYPE }));

const VERIFICATION_AUTO_TYPE = {
  SAMSUB: 0,
  VERIFF: 1,
  SAMSUB_LIVENESS_CHECK: 2,
};

const VERIFICATION_AUTO_TYPE_LIST = [
  {
    id: VERIFICATION_AUTO_TYPE.SAMSUB,
    caption: 'SumSub',
  },
  {
    id: VERIFICATION_AUTO_TYPE.VERIFF,
    caption: 'Veriff',
  },
  {
    id: VERIFICATION_AUTO_TYPE.SAMSUB_LIVENESS_CHECK,
    caption: 'SumSub liveness check',
  },
].filter((e) => checkConstAvailability(e, { VERIFICATION_AUTO_TYPE }));

const TECHNICAL_WORK_TYPE = {
  STOP_P2P: 'stopP2P',
  STOP_REGISTRATION: 'stopRegistration',
  STOP_TRADE: 'stopTrade',
  STOP_TRANSACTION_CONFIRM: 'stopTransactionConfirm',
  STOP_TRANSACTIONS: 'stopTransactions',
};

const TECHNICAL_WORK_TYPE_LIST = [
  {
    id: TECHNICAL_WORK_TYPE.STOP_P2P,
    caption: 'Stop P2P',
  },
  {
    id: TECHNICAL_WORK_TYPE.STOP_REGISTRATION,
    caption: 'Stop registration',
  },
  {
    id: TECHNICAL_WORK_TYPE.STOP_TRADE,
    caption: 'Stop trading',
  },
  {
    id: TECHNICAL_WORK_TYPE.STOP_TRANSACTION_CONFIRM,
    caption: 'Stop transaction confirm',
  },
  {
    id: TECHNICAL_WORK_TYPE.STOP_TRANSACTIONS,
    caption: 'Stop transactions',
  },
].filter((e) => checkConstAvailability(e, { TECHNICAL_WORK_TYPE }));

const KYT_RISKS = {
  UNDEFIEND: 1,
  OTHER_MINER: 2,
  WALLET: 3,
  EXCHANGE_MODERATE: 4,
  EXCHANGE_HIGH: 5,
  EXCHANGE_VERY_HIGH: 6,
  LIQUIDITY_POOLS: 7,
  MARKETPLACE: 8,
  P2P_HIGH_RISK: 9,
  MERCHANT: 10,
  PAYMENT: 11,
  BRIDGE: 12,
  SMART_CONTRACT: 13,
  LENDING: 14,
  LIQUIDITY: 15,
  PHARMACY: 16,
  ICO: 17,
  NFT: 18,
  ENFORCEMENT: 19,
  GAMBLING: 20,
  DARK: 21,
  CHILD_EXPLOITATION: 22,
  ILLEGAL: 23,
  SANCTIONS: 24,
  SCAM: 25,
  STOLEN: 26,
  SEIZED: 27,
  TERRORISM: 28,
  FRAUD: 29,
  MALWARE: 30,
};

const KYT_RISKS_LIST = [
  {
    id: KYT_RISKS.UNDEFIEND,
    caption: 'Undefiend',
    description: 'Uncertain source (Possibility of erroneous or missing analysis)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.OTHER_MINER,
    caption: 'Other miner',
    description: 'Mined by an independent miner (May include mixers, trace evasion)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.WALLET,
    caption: 'Wallet',
    description: 'Private wallet (Potential AML evasion (P2P/OTC deals))',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.EXCHANGE_MODERATE,
    caption: 'Exchange moderate',
    description: 'Exchange, moderate risk (Some exchanges are grey, may have history of anonymous deposits)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.EXCHANGE_HIGH,
    caption: 'Exchange high',
    description: 'Exchange, high risk (Possible sanctions, risk of blocking)',
    defaultValue: 50,
  },
  {
    id: KYT_RISKS.EXCHANGE_VERY_HIGH,
    caption: 'Exchange very high',
    description: 'Exchange, very high risk (Clear regulatory issues)',
    defaultValue: 30,
  },
  {
    id: KYT_RISKS.LIQUIDITY_POOLS,
    caption: 'Liquidity pools',
    description: 'Decentralized liquidity pool (Possibility of anonymous mixing)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.MARKETPLACE,
    caption: 'Marketplace',
    description: 'Marketplaces (Potential shadow deals)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.P2P_HIGH_RISK,
    caption: 'P2P High Risk',
    description: 'P2P platforms, high risk (Anonymity, fraud risk)',
    defaultValue: 50,
  },
  {
    id: KYT_RISKS.MERCHANT,
    caption: 'Merchant',
    description: 'Commercial merchant (Possible trace and AML evasion)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.PAYMENT,
    caption: 'Payment',
    description: 'Payment service (Possibility of sanctions evasion via anonymization)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.BRIDGE,
    caption: 'Bridge',
    description: 'Cross-chain bridge (Anonymization, trace evasion)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.SMART_CONTRACT,
    caption: 'Smart contract',
    description: 'Smart contract (May be used for mixing)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.LENDING,
    caption: 'Lending',
    description: 'Decentralized lending service (Possibility of cashing out without trace)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.LIQUIDITY,
    caption: 'Liquidity',
    description: 'Liquidity pool/DEX (High ownership turnover rate)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.PHARMACY,
    caption: 'Pharmacy',
    description: 'Link to online pharmacies (Possible risk of illegal activity)',
    defaultValue: 50,
  },
  {
    id: KYT_RISKS.ICO,
    caption: 'ICO',
    description: 'Initial Coin Offering (Risk of involvement in questionable projects)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.NFT,
    caption: 'NFT',
    description: 'Non-fungible tokens (May be used for laundering)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.ENFORCEMENT,
    caption: 'Enforcement',
    description: 'Link to law enforcement (Potentially seized funds)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.GAMBLING,
    caption: 'Gambling',
    description: 'Gambling (AML risks and illegal operations)',
    defaultValue: 10,
  },
  {
    id: KYT_RISKS.DARK,
    caption: 'Dark',
    description: 'Darknet (Direct AML/CTF risk)',
    defaultValue: 10,
  },
  {
    id: KYT_RISKS.CHILD_EXPLOITATION,
    caption: 'Child exploitation',
    description: 'Child exploitation (Strictly prohibited)',
    defaultValue: 1,
  },
  {
    id: KYT_RISKS.ILLEGAL,
    caption: 'Illegal',
    description: 'Illegal activity (Strictly prohibited)',
    defaultValue: 10,
  },
  {
    id: KYT_RISKS.SANCTIONS,
    caption: 'Sanctions',
    description: 'Sanctioned addresses (Direct risk of sanctions exposure)',
    defaultValue: 5,
  },
  {
    id: KYT_RISKS.SCAM,
    caption: 'Scam',
    description: 'Scam addresses/actions (Direct AML/Fraud risk)',
    defaultValue: 5,
  },
  {
    id: KYT_RISKS.STOLEN,
    caption: 'Stolen',
    description: 'Stolen funds (Direct AML/Fraud risk)',
    defaultValue: 1,
  },
  {
    id: KYT_RISKS.SEIZED,
    caption: 'Seized',
    description: 'Seized funds (Potentially frozen/seized)',
    defaultValue: 1,
  },
  {
    id: KYT_RISKS.TERRORISM,
    caption: 'Terrorism',
    description: 'Terrorism financing (Direct AML/CTF risk)',
    defaultValue: 100,
  },
  {
    id: KYT_RISKS.FRAUD,
    caption: 'Fraud',
    description: 'Fraud (Direct AML/Fraud risk)',
    defaultValue: 5,
  },
  {
    id: KYT_RISKS.MALWARE,
    caption: 'Malware',
    description: 'Malware (Direct AML/Fraud risk)',
    defaultValue: 5,
  },
].filter((e) => checkConstAvailability(e, { KYT_RISKS }));

export default {
  EXCHANGE_URL,
  VERIFICATION_TYPE,
  VERIFICATION_TYPE_LIST,
  VERIFICATION_AUTO_TYPE,
  VERIFICATION_AUTO_TYPE_LIST,
  TECHNICAL_WORK_TYPE,
  TECHNICAL_WORK_TYPE_LIST,
  KYT_RISKS,
  KYT_RISKS_LIST,
};
